import React, { Fragment } from 'react';
import "./paginator.css";

const Paginator = (
  {
    changePage,
    page,
    data,
    totalPages,
    meta,
    callback
  }
) => {
  return (
    <Fragment>
      <div
        className="paginator__arrow"
        onClick={() => {
            changePage({page, previous: true, ...meta});
            callback ? callback() : null;
          }
        }
      >
        <i className="fas fa-angle-left " />
      </div>
      <div style={{
        width: '50%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <span>{page}/{totalPages || Object.keys(data).length} </span>
      </div>
      <div
        className="paginator__arrow"
        onClick={() => {
          changePage({page, next: true, ...meta});
          callback ? callback() : null;
        }}
      >
        <i className="fas fa-angle-right" />
      </div>
    </Fragment>
  )
};

export default Paginator;


// WEBPACK FOOTER //
// ./src/components/paginator/paginator-component.js